import React, { useEffect, useId } from "react";
import { createPortal } from "react-dom";
import whoSignSelfImg from "../../../../../assets/signPdf/who-sign-self.png";
import whoSignOthersImg from "../../../../../assets/signPdf/who-sign-others.png";
import "./SignPdfWhoIsSigningModal.css";

const PersonIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <circle
      cx="12"
      cy="8"
      r="3.25"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M5.5 19c1.4-3.2 3.5-4.8 6.5-4.8s5.1 1.6 6.5 4.8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const PeopleIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <circle
      cx="9"
      cy="8"
      r="2.75"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <circle
      cx="16.5"
      cy="9"
      r="2.25"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      d="M3.8 18.5c1.1-2.6 2.8-3.9 5.2-3.9s4.1 1.3 5.2 3.9"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M14.2 18.5c.7-1.6 1.8-2.5 3.5-2.5 1.4 0 2.4.7 3.1 1.8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Post-upload chooser: Sign myself vs Get signatures from others (Coming Soon).
 */
const SignPdfWhoIsSigningModal = ({
  open = false,
  onClose = () => {},
  onSignMyself = () => {},
}) => {
  const titleId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || typeof document === "undefined") return null;

  const node = (
    <div className="sp-who-root" role="presentation">
      <button
        type="button"
        className="sp-who-backdrop"
        aria-label="Close"
        onClick={onClose}
      />
      <div
        className="sp-who-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <button
          type="button"
          className="sp-who-close"
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>

        <h2 id={titleId} className="sp-who-title">
          Choose who’s signing
        </h2>

        <div className="sp-who-grid">
          <article className="sp-who-card">
            <div className="sp-who-art sp-who-art--self">
              <img
                className="sp-who-art__img"
                src={whoSignSelfImg}
                alt=""
                draggable={false}
              />
            </div>
            <div className="sp-who-body">
              <button
                type="button"
                className="sp-who-cta"
                onClick={onSignMyself}
              >
                <PersonIcon />
                <span>Sign myself</span>
              </button>
              <p className="sp-who-hint">
                Create a signature and sign a document.
              </p>
            </div>
          </article>

          <article className="sp-who-card sp-who-card--soon">
            <div className="sp-who-art sp-who-art--others">
              <span className="sp-who-verified">
                <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
                  <path
                    d="M8 1.5l1.7 1.1 2 .3.8 1.8 1.8.8-.3 2L15 9.5l-1.1 1.7-.3 2-1.8.8-1.8.3L8 15.5l-1.7-1.1-2-.3-.8-1.8-1.8-.8.3-2L1 9.5l1.1-1.7.3-2 1.8-.8 1.8-.3L8 1.5z"
                    fill="currentColor"
                  />
                  <path
                    d="M5.6 8.1l1.5 1.5 3.2-3.2"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Verified signing
              </span>
              <img
                className="sp-who-art__img"
                src={whoSignOthersImg}
                alt=""
                draggable={false}
              />
            </div>
            <div className="sp-who-body">
              <button
                type="button"
                className="sp-who-cta sp-who-cta--disabled"
                disabled
                aria-disabled="true"
                title="Coming soon"
              >
                <PeopleIcon />
                <span>Get signatures from others</span>
              </button>
              <p className="sp-who-hint sp-who-hint--soon">Coming soon</p>
            </div>
          </article>
        </div>
      </div>
    </div>
  );

  return createPortal(node, document.body);
};

export default SignPdfWhoIsSigningModal;
